var React = require('react');

function Leaf (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M45.85 99.127c-13.208-2.347-9.782-10.13-9.782-10.13 1.068-2.912 7.025-5.543 7.025-5.543-14.719-.114-23.875-8.533-23.875-8.533-6.032-8.01-.35-10.863 1.774-11.77 2.126-.906 8.838-1.291 8.838-1.291C-1.522 55.155.012 36.362.012 36.362c.182-8.343 8.216-6.883 8.216-6.883 3.507.398 12.389 5.944 12.389 5.944C4.457 18.637 9.212 4.938 9.212 4.938c2.48-8.6 12.351-3.353 12.351-3.353 10.812 5.875 17.64 32.15 17.64 32.15-2.383-9.344 0-17.328 0-17.328 2.543-7.719 10.357-4.563 10.357-4.563 12.097 5.146 15.375 25.607 15.375 25.607.243-.93 9.965-15.54 16.123 2.187 6.236 17.762-2.162 32.988-2.162 32.988.971-2.295 13.084-17.973 15.095-4.162 1.092 7.23-6.235 20.966-18.131 26.802-13.223 6.452-25.107 4.72-30.01 3.861z"}));
}

Leaf.defaultProps = {"viewBox":"0 0 95 100"};

module.exports = Leaf;

Leaf.default = Leaf;
